import { useEffect, useState } from 'react';

export const useOnDataLoaded = (isLoading: boolean, callback?: Function) => {
    const [isCallbackCalled, setIsCallbackCalled] = useState(false);

    useEffect(() => {
        if (!isLoading && callback && !isCallbackCalled) {
            callback();
            setIsCallbackCalled(true);
        }
    }, [callback, isLoading, isCallbackCalled]);
};
